import { OctreeManager, Node, Box3Status } from "./OctreeManager";
import * as THREE from 'three';

export class RayIntersection {

    constructor(private rayCaster: THREE.Raycaster) {
    }

    public getTargets(octreeManager: OctreeManager): THREE.Intersection[] {
        const status = octreeManager.nodeStatus;

        let objects = [];
        const getObjects = (_status: Node) => {
            if (_status.children.length < 1) {
                for (let i = 0; i < _status.box3Status.length; i++) {
                    objects.push(_status.box3Status[i].object);
                }
                return;
            }
            for (let j = 0; j < _status.children.length; j++) {
                if (this.rayCaster.ray.intersectsBox(_status.children[j].box)) {
                    getObjects(_status.children[j]);
                }
            }
        }
        getObjects(status);
        objects = [... new Set(objects)];
        const hitObj = this.rayCaster.intersectObjects(objects, true);
        // console.log(hitObj);

        return hitObj;
    }

    public getTargets_(status: Box3Status[]) {
        if (status == null) return [];

        let objects = [];
        for (let i = 0; i < status.length; i++) {
            if (this.rayCaster.ray.intersectsBox(status[i].box)) {
                objects.push(status[i].object);
            }
        }

        // objects = [... new Set(objects)];
        // const hitObj = this.rayCaster.intersectObjects(objects, true);
        const visibleObjects = [... new Set(objects)].filter((object) => object.visible);
        const hitObj = this.rayCaster.intersectObjects(visibleObjects, true);

        return hitObj;
    }
}
